/**
 * Converts base64url string to Uint8Array
 * Base64url uses - and _ instead of + and /, and doesn't use padding
 */
export function base64urlToUint8Array(base64url: string): Uint8Array {
  // Convert base64url to standard base64
  let base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
  
  // Add padding if needed
  while (base64.length % 4) {
    base64 += '=';
  }
  
  // Decode base64 to binary string
  const binaryString = atob(base64);
  
  // Convert binary string to Uint8Array with explicit ArrayBuffer
  // Using ArrayBuffer constructor ensures the buffer type is ArrayBuffer, not ArrayBufferLike
  const buffer = new ArrayBuffer(binaryString.length);
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  
  return bytes;
}

/**
 * Converts Uint8Array to base64url string
 * Base64url uses - and _ instead of + and /, and removes padding
 */
export function uint8ArrayToBase64url(bytes: Uint8Array): string {
  // Convert Uint8Array to binary string
  let binaryString = '';
  for (let i = 0; i < bytes.length; i++) {
    binaryString += String.fromCharCode(bytes[i]);
  }
  
  // Encode to base64
  const base64 = btoa(binaryString);
  
  // Convert to base64url (replace + with -, / with _, remove padding)
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

